import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IArticleContentDto } from 'src/app/core/dtos/interfaces/i-article-content-dto';

@Injectable({
  providedIn: 'root',
})
export class ContentStateService {
  private contentDtoSubject: BehaviorSubject<IArticleContentDto | null>;
  public contentDto$: Observable<IArticleContentDto | null>;

  constructor() {
    this.contentDtoSubject = new BehaviorSubject<IArticleContentDto | null>(
      null
    );
    this.contentDto$ = this.contentDtoSubject.asObservable();
  }

  public setContentDto(articleDto: IArticleContentDto): void {
    this.contentDtoSubject.next(articleDto);
  }

  public getContentDto$(): Observable<IArticleContentDto | null> {
    return this.contentDto$;
  }
}
